import { render, staticRenderFns } from "./InterviewDetail.vue?vue&type=template&id=197d7472"
import script from "./InterviewDetail.vue?vue&type=script&lang=js"
export * from "./InterviewDetail.vue?vue&type=script&lang=js"
import style0 from "./InterviewDetail.vue?vue&type=style&index=0&id=197d7472&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports